define('areas/activityfeed/models/bindable',["require", "exports"], function (require, exports) {
    "use strict";
    var ActivityVM = (function () {
        function ActivityVM() {
        }
        return ActivityVM;
    }());
    exports.ActivityVM = ActivityVM;
});

